import React, { useEffect, useState } from "react";
import { Sms, CloseCircle, Eye, EyeSlash } from "iconsax-react";
import { GoLock } from "react-icons/go";
import { Link, useNavigate } from "react-router-dom";
import ProgressBar from "@ramonak/react-progress-bar";
import { LSSB, setUserData } from "../utils/LSSB_live";
import { ClipLoader } from "react-spinners";
import { enqueueSnackbar } from "notistack";

const Login = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [idType, setIdType] = useState("LASRRA");
  const [idNumber, setIdNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState("");

  useEffect(() => {
    let user = sessionStorage.getItem("lssbAdminData");
    if (user) {
      navigate("/");
    }
  }, []);

  const toggle = () => {
    setOpen(!open);
  };
  const handleSignin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      let res = await LSSB.make_API_call({
        _endpoint: "auth_user",
        auth_key: idNumber,
        auth_key_type: idType === "LASRRA" ? "lassra" : idType.toLowerCase(),
        password: password,
      });
      console.log(res);
      if (res?.success == true) {
        setUserData(res?.data);
        console.log(res?.data?.user);
        enqueueSnackbar(res?.data?.msg, { variant: "success" });

        navigate("/");
        setIsLoading(false);
      } else {
        enqueueSnackbar(res?.error?.msg, { variant: "error" });

        if (
          res?.error?.msg ===
          "Email verification pending. Resend OTP to verify email address"
        ) {
          try {
            let res = await LSSB.make_API_call({
              _endpoint: "auth_user",
              email: idNumber,
              auth_action: "resend_verify_email_otp",
            });

            if (res?.success == true) {
              enqueueSnackbar(res?.data?.msg, { variant: "success" });
              navigate("/otp", { state: { email:  idNumber} });
            } else {
              enqueueSnackbar(res?.error?.msg, { variant: "error" });
            }
          } catch (error) {
            enqueueSnackbar(error.message, { variant: "error" });
          }
        }

        setIsLoading(false);
      }
    } catch (e) {}
  };

  return (
    <div className="h-screen w-full flex items-center ">
      <div className="h-full w-[20%] md:w-[50%] relative hidden md:block">
        {" "}
        <img
          src="./asset/homeImage.png"
          alt=""
          className="object-cover h-full w-full -z-10"
        />
      </div>
      <div className="h-full w-full md:w-[50%] bg-[#ffff] flex justify-center items-center">
        <div className="md:hidden flex gap-[16px] items-center absolute z-10 top-[24px] left-[24px] md:top-[48px] md:left-[48px]">
          <img
            src="./asset/lssbLogo.png"
            alt="logo"
            className="h-[40px] w-[40px] md:h-[58px] md:w-[58px]"
          />
          <div>
            <p className="text-sm  md:text-base text-[#7C8493] font-medium md:font-semibold leading-[20px]">
              Lagos State
            </p>
            <p className="text-sm  md:text-base text-[#7C8493] font-medium md:font-semibold leading-[20px]">
              Scholarship Board
            </p>
          </div>
        </div>

        <div className="bg-[#ffff] rounded-[16px] w-[360px] max-w-[360px] sm:w-[480px] sm:max-w-[480px] md:w-[408px] md:max-w-[409px] pt-[24px] md:pt-[32px]  pb-[24px] ">
          <h2 className="text-[20px] md:text-[24px] xl:text-[28px] text-center font-normal leading-[35px] text-black mb-[20px] md:mb-[30px] xl:mb-[50px]">
            Log In
          </h2>

          <form onSubmit={handleSignin} className=" w-full">
            <div className="mb-[24px]">
              <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
                Login With
              </label>
              <div className=" ">
                <select
                  type="text"
                  placeholder={`Enter   ID`}
                  className="w-full h-[50px] px-[16px] py-[12px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                  required
                  autoComplete="on"
                  value={idType}
                  onChange={(event) => {
                    setIdType(event.target.value);
                  }}
                  autoCapitalize="off"
                  autoCorrect="off"
                  spellCheck="false"
                >
                  <option value="LASRRA">LASRRA</option>
                  <option value="USERNAME">USERNAME</option>
                  <option value="EMAIL">EMAIL</option>
                </select>
              </div>
            </div>
            <div className="mb-[24px]">
              <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
                Enter {idType}{" "}
                {idType === "NIN" || idType === "LASRRA" ? "ID" : ""}
              </label>
              <div className=" ">
                <input
                  type="text"
                  placeholder={`Enter ${idType}`}
                  className="w-full h-[50px] px-[16px] py-[12px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                  required
                  autoComplete="on"
                  value={idNumber}
                  onChange={(e) => {
                    setIdNumber(e.target.value);
                  }}
                  autoCapitalize="off"
                  autoCorrect="off"
                  spellCheck="false"
                />
              </div>
            </div>

            <div className="mb-[8px]">
              <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
                Password
              </label>
              <div className=" relative  flex items-center">
                <div className="absolute right-[16px]">
                  {open === false ? (
                    <Eye size="16" color="#020408" onClick={toggle} />
                  ) : (
                    <EyeSlash size="16" color="#98A2B3" onClick={toggle} />
                  )}
                </div>{" "}
                <input
                  type={open === false ? "password" : "text"}
                  placeholder=""
                  className="w-full h-[50px] px-[16px] py-[12px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                  required
                  autoComplete="on"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  autoCapitalize="off"
                  autoCorrect="off"
                  spellCheck="false"
                />
              </div>
            </div>
            <Link to="/forgotpassword" className="mb-[24px]">
              {" "}
              <button
                type="button"
                className="font-medium text-sm text-[#AF8544]"
              >
                Forgot Password?
              </button>
            </Link>

            <button
              type="submit"
              className="w-full py-[14px] mt-[24px] text-center text-white bg-[#AF8544]  flex items-center justify-center mb-[20px] md:mb-[32px]"
            >
              <p className="text-sm font-medium leading-[20px] mr-3">
                Continue
              </p>{" "}
              {isLoading && <ClipLoader color={"white"} size={20} />}
            </button>

            <div className="text-[14px] leading-[20px] text-[#7C8493] flex j items-center mb-[13px] ">
              <p>Don't have an account? &nbsp;</p>
              <Link to="/signup">
                {" "}
                <button className="font-medium text-[#AF8544]">Signup</button>
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default Login;
